import React from 'react';
import { escape } from 'lodash';
import { getLocalUserData } from '../../../components/UserData/user';
import { getFileDownloadUrl } from '../../../assets/apis/base';
import { Tooltip, Icon } from '@roo/roo';
import styled from 'styled-components';
const Root = styled.div`
    padding: 41px;
    //background: #FFFFFF;
    border: 1px dashed #cccccc;
    border-radius: 2px;
    text-align: center;
    p {
        margin-top: 10px;
    }
    p:first-child {
        margin-top: 0;
    }
    .roo-icon-file {
        height: 20px;
        width: 20px;
        font-size: 20px;
        color: rgb(25, 140, 255);
        margin-right: 8px;
        position: relative;
        top: -3px;
    }
    .text-line {
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 2px 0;
        max-width: 200px;
        white-space: nowrap;
        margin-right: 10px;
        position: relative;
        top: 3px;
        color: #222;
    }
`;

export function FilesView(props) {
    const { value } = props;

    const files = Array.isArray(value) ? value : [value];

    return (
        <Root className={'files-view-list'} style={props.style}>
            {files.map((f) => {
                const name = escape(f.split('({&!$!&})').filter(Boolean).pop());
                return (
                    <p style={{ overflow: 'visible' }}>
                        <Icon name={'file'} />

                        <Tooltip content={name}>
                            <span className={'text-line'}>{name}</span>
                        </Tooltip>
                        <a
                            href="javascript:void 0"
                            style={{ overflow: 'visible', color: '#666' }}
                            onClick={() => {
                                const { mtUid } = getLocalUserData();
                                getFileDownloadUrl({ fileName: f.key || f, userId: mtUid, needWatermark: true }).then((res) => {
                                    if (res) {
                                        downloadUrl(res);
                                    }
                                });
                            }}
                        >
                            查看
                        </a>
                    </p>
                );
            })}
        </Root>
    );
}

function downloadUrl(href) {
    // 创建隐藏的可下载链接
    const eleLink = document.createElement('a');
    eleLink.style.display = 'none';
    eleLink.href = href;
    eleLink.target = '_blank';
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
}
